import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IPurchaseKingSectionProps {
  $bgColor?: string;
  $textColor?: string;
  $pointColor?: string;
  $emphasisTextColor?: string;
}

export const PurchaseKingSection = styled.div<IPurchaseKingSectionProps>`
  padding: 32px 0;
  background: #fff;

  ${({ $bgColor }) =>
    $bgColor &&
    css`
      background: ${$bgColor};
    `}

  .section-title {
    padding: 0 20px 12px;

    .sub-title {
      color: #acacac;
    }
  }

  .my-amount-box {
    margin: 0 20px 32px;
    padding: 16px 20px;
    background: #f9f9f9;
    text-align: center;
  }

  .my-amount-label {
    font-size: 15px;
    line-height: 130%;
    font-weight: 500;
    color: #333;
  }

  .my-amount-value {
    margin-top: 4px;
    font-size: 24px;
    font-weight: 600;
    line-height: 120%;
    color: #000;

    .unit {
      margin-left: 1px;
    }
  }

  .ranking-wrap {
    position: relative;
  }

  .ranking-table {
    padding: 0 20px;
  }

  .table-wrapper table {
    background-color: transparent;

    th,
    td {
      letter-spacing: -0.084px;
    }

    th {
      font-size: 12px;
    }

    th:nth-child(1) {
      width: 20%;
    }

    th:nth-child(2),
    th:nth-child(3) {
      width: 40%;
    }
  }

  .ranking-table .is-top {
    font-weight: 600;
    color: #ff4600;
  }

  .ranking-more-btn {
    display: flex;
    justify-content: center;
    min-width: 170px;
    height: 40px;
    margin: 32px auto 0;
    padding: 0 20px;
    border: 1px solid #e2e2e2;
    background: transparent;
    font-size: 14px;
    line-height: 130%;
    font-weight: 500;
    color: #000;

    svg {
      margin-left: 2px;

      path {
        fill: #000;
      }
    }
  }

  /* 비로그인: 랭킹은 흐리게 깔아두고 하단은 배경색으로 페이드시킨 뒤 로그인 버튼을 얹는다. */
  &.is-not-login {
    .my-amount-value {
      font-size: 18px;
    }

    .ranking-inner {
      filter: blur(2.5px);
      pointer-events: none;
      user-select: none;
    }

    .login-dim {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      ${mixin.flex({ align: 'center', justify: 'center' })};

      &:after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: -10px;
        height: 180px;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          #fff 100%
        );
      }
    }

    .login-btn {
      min-width: 160px;
      height: 44px;
      padding: 0 24px;
      border-radius: 48px;
      background: #000;
      font-size: 14px;
      font-weight: 600;
      color: #fff;
      box-shadow: 2px 3px 9px 0 rgba(0, 0, 0, 0.25);
      z-index: 1;

      svg {
        margin-left: 4px;

        path {
          stroke: #fff;
        }
      }
    }
  }

  /* 커스텀 컬러: 배경/본문 색과 페이드, 포인트 컬러를 함께 맞춘다. */
  ${({ $bgColor, $textColor }) =>
    ($bgColor || $textColor) &&
    css`
      .my-amount-box {
        background: rgba(255, 255, 255, 0.4);
      }

      .my-amount-label,
      .my-amount-value,
      .table-wrapper table thead th,
      .table-wrapper table tbody td {
        color: ${$textColor};
      }

      .ranking-more-btn {
        color: ${$textColor};

        svg path {
          fill: ${$textColor};
        }
      }

      &.is-not-login .login-dim {
        &:after {
          background: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0) 0%,
            ${$bgColor} 100%
          );
        }
      }
    `}

  ${({ $pointColor, $emphasisTextColor }) =>
    ($pointColor || $emphasisTextColor) &&
    css`
      .ranking-table .is-top {
        color: ${$pointColor};
      }
    `}

  &.bg-type-black {
    background: #000;

    .my-amount-box {
      background: #1a1a1a;
    }

    .my-amount-label,
    .my-amount-value,
    .main-title {
      color: #fff;
    }

    .table-wrapper table {
      border-top-color: #fff;
      border-bottom-color: #fff;

      tbody td {
        border-color: #333;
      }

      th,
      td {
        color: #ccc;
      }
    }

    .ranking-more-btn {
      border-color: #555;
      color: #fff;

      svg path {
        fill: #fff;
      }
    }

    &.is-not-login {
      .login-dim {
        &:after {
          background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000 100%);
        }
      }

      .login-btn {
        background: #fff;
        color: #000;

        svg path {
          stroke: #000;
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('32')} 0;

    .section-title {
      padding: ${mixin.pxToVw('0 20 12')};
    }

    .my-amount-box {
      margin: ${mixin.pxToVw('0 20 32')};
      padding: ${mixin.pxToVw('16 20')};
    }

    .my-amount-label {
      font-size: ${mixin.pxToVw('15')};
    }

    .my-amount-value {
      margin-top: ${mixin.pxToVw('4')};
      font-size: ${mixin.pxToVw('24')};
    }

    .ranking-table {
      padding: ${mixin.pxToVw('0 20')};
    }

    .table-wrapper table {
      th,
      td {
        letter-spacing: -${mixin.pxToVw('0.084')};
      }

      th {
        font-size: ${mixin.pxToVw('12')};
      }
    }

    .ranking-more-btn {
      min-width: ${mixin.pxToVw('170')};
      height: ${mixin.pxToVw('40')};
      margin: ${mixin.pxToVw('20')} auto 0;
      font-size: ${mixin.pxToVw('14')};

      svg {
        margin-left: ${mixin.pxToVw('4')};
      }
    }

    &.is-not-login {
      .my-amount-value {
        font-size: ${mixin.pxToVw('18')};
      }

      .login-dim {
        &:after {
          bottom: -${mixin.pxToVw('10')};
          height: ${mixin.pxToVw('180')};
        }
      }

      .login-btn {
        min-width: ${mixin.pxToVw('160')};
        height: ${mixin.pxToVw('44')};
        padding: ${mixin.pxToVw('0 24')};
        border-radius: ${mixin.pxToVw('48')};
        font-size: ${mixin.pxToVw('14')};

        svg {
          margin-left: ${mixin.pxToVw('4')};
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 65px 0;

    .section-title {
      padding: 0 0 20px 0;
    }

    .my-amount-box {
      width: 1000px;
      max-width: 100%;
      margin: 0 auto 48px;
      padding: 24px 40px;
    }

    .my-amount-label {
      font-size: 20px;
    }

    .my-amount-value {
      margin-top: 8px;
      font-size: 38px;

      .unit {
        margin-left: 2px;
        font-size: 26px;
      }
    }

    .ranking-wrap {
      width: 1326px;
      margin: 0 auto;
    }

    .ranking-table {
      padding: 0;
    }

    .table-wrapper table {
      table-layout: fixed;

      th {
        text-align: center;
        color: #555;
      }

      tbody td {
        border-color: #eee;
      }

      th,
      td {
        padding: 13px 0;
        line-height: 135%;
        letter-spacing: -0.114px;
        font-weight: 500;
      }

      th {
        font-size: 17px;
      }

      td {
        font-size: 19px;
      }

      th:nth-child(1),
      th:nth-child(4) {
        width: 147px;
      }

      th:nth-child(2),
      th:nth-child(3),
      th:nth-child(5),
      th:nth-child(6) {
        width: 258px;
      }

      th:nth-child(3),
      td:nth-child(3),
      th:nth-child(6),
      td:nth-child(6) {
        padding: 13px 40px;
      }

      /* 좌(1~10위) / 우(11~20위) 사이 가운데 구분선.
         border-collapse: collapse에서는 셀 border가 테이블 border를 이겨
         테이블 상/하단 라인을 끊으므로, 충돌하지 않는 box-shadow로 그린다. */
      th:nth-child(3),
      td:nth-child(3) {
        box-shadow: inset -1px 0 0 #eee;
      }
    }

    .ranking-more-btn {
      width: 260px;
      height: 56px;
      margin-top: 32px;
      font-size: 16px;
    }

    &.is-not-login {
      .my-amount-value {
        font-size: 28px;
      }

      .login-btn {
        min-width: 238px;
        height: 64px;
        margin-bottom: 60px;
        padding: 0 56px;
        border-radius: 62px;
        font-size: 18px;
        box-shadow: 3.444px 4.593px 9.185px 0 rgba(0, 0, 0, 0.25);

        svg {
          width: 16px;
          height: 16px;
          margin-left: 6px;
        }
      }

      .login-dim:after {
        height: 150px;
      }

      .ranking-inner {
        filter: blur(3px);
      }
    }

    &.bg-type-black {
      .table-wrapper table {
        /* 좌(1~10위) / 우(11~20위) 사이 가운데 구분선.
           테이블 상/하단 라인이 끊기지 않도록 border 대신 box-shadow로 그린다. */
        th:nth-child(3),
        td:nth-child(3) {
          box-shadow: inset -1px 0 0 #333;
        }
      }
    }
  }
`;
